import React from 'react';

import './output-cell.css';

export function OutputCell(props) {
    const { label, text } = props;
    return (
        <>
            <div className="small d-sm-none font-weight-bold">{label}</div>
            <div className="output-cell-text">{text}</div>
        </>
    );
}
